import { useTranslation } from "react-i18next";
import objetoService from "../axios/services/destino";
import ObjetosScreen from "../components/Objetos/Objetos";
import { useNavigate } from 'react-router-dom';

export default function DestinosScreen() {
  const navigate = useNavigate();

  const target = "Destino";
  const { t } = useTranslation();
  const title = t("common.destinos");
  return (
    <ObjetosScreen target={target} navigation={navigate} objetoService={objetoService} title={title} />
  );
}

